import { useMutation } from 'react-query';

import { createTag as mutationFn } from 'api/endPoints/createTag';

export const useMutationCreateTag = () => {
    return useMutation<string, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

interface QueryParams {
    customerId: number;
    name: string;
    projectId: number;
}
